import { isEmpty, cloneDeep, uniq, find } from 'lodash'
import SelectDropdown from '@/components/component/Reuse/SelectDropdown/SelectDropdown.vue'
import { userGroupBulkEdit, getIamgUserGroupsList, getIamUsers } from '@/libs/api/api'
import InfiniteLoading from 'vue-infinite-loading';
import constants from '@/libs/constant/constants';
import { message, loader, urlValidation } from '@/libs/helper';

export default {
    name: 'BulkUpdate',
    components: {
        SelectDropdown,
        InfiniteLoading
    },
    // mixins: [bulkUpload],
    props: {
        markedTableItems: {
            type: Array,
            default: () => { }
        },
        tableData: {
            type: Array,
            default: () => { }
        },
        organsiationID: {
            type: String,
            default: () => ''
        }
    },
    created() {
        this.OWNER = 'OWNER'
        this.MEMBER = 'MEMBER'
        this.NO = 'NO'
        this.YES = 'YES'
        this.baseUrl = process.env.VUE_APP_ENV === 'production' ? 'accura.onl' : process.env.VUE_APP_ENV === 'staging' ? 'web-staging.accura.onl' : 'web-dev.accura.onl'
    },
    beforeMount() {

    },
    computed: {
        table() {
            return this.tableData.filter(item => {
                if (new Set(this.markedTableItems).has(item._id)) return true
            })
        }
    },
    mounted() {
        this.details = JSON.parse(localStorage.getItem('details'))
        this.fetchUserDetails(this.organsiationID)
    },
    data() {
        return {
            isEmpty,
            step: 1,
            details: [],
            isLoadMore: true,
            isConfirm: false,
            isFinal: false,
            isProgress: false,
            markedItems: [],
            checkedData: [],
            bulkUpdateData: {
                addToSet: this.NO || 'NO',
                groupIds: '',
                group_members: []
            },
            progress: 0,
            limit: 50,
            skip: 0,
            sort: 'screen_name',
            order: 'asc',
            setsList: [],
            userData: [],
            groupIdName: '',
            groupMemberList: [],
            groupMemberName: []
        }
    },
    methods: {
        /**
         * disable test button
         * @returns is-disabled true/false
         */
        disabledTestButtonBackup() {
            if ((this.secondary !== this.EXTERNAL || this.bulkUpdateData.secondary_url.external_url === '' || !urlValidation(this.bulkUpdateData.secondary_url.external_url))) return true
            return false
        },
        addGroupMemeber (id) {
            if (!this.groupMemberList.includes(id)) {
                this.groupMemberList.push(id)
            } else {
                const index = this.groupMemberList.indexOf(id)
                if (index > -1) {
                    this.groupMemberList.splice(index, 1);
                }
            }
            console.log('groupMemberList', this.groupMemberList)
        },
        buttonAction(type) {
            switch (type) {
                case 'back':
                    this.step = 1
                    this.isConfirm = false
                    break
                case 'cancel':
                    this.$emit('close')
                    break
                case 'next':
                    if (!isEmpty(this.markedItems)) {
                        this.checkedData = cloneDeep(this.markedItems)
                        this.step = 2
                        this.isConfirm = true
                    }
                    if (this.markedItems.includes('group_members')) {
                        for (let i = 0; i < this.groupMemberList.length; i++) {
                            for (let j = 0; j < this.userData.length; j++) {
                                if (!this.groupMemberName.includes(this.userData[j].userDetails[0].screen_name) && this.userData[j]._id === this.groupMemberList[i]) {
                                    this.groupMemberName.push(this.userData[j].userDetails[0].screen_name)
                                }
                            }
                        }
                    }
                    break
                case 'done':
                    this.$emit('refreshPage')
                    this.$emit('close')
                    break
            }
        },
        fetchNewRecord: async function () {
            //call api and set data to table
            let params = `?skip=${this.skip}&limit=${this.limit}&sort=${this.sort}&order=${this.order}`
            let orgID = this.organsiationID
            loader(this, true)
            let body = { searchText: '' }
            await getIamgUserGroupsList(orgID, params, body).then((response) => {
                if (response && response.result) {
                    this.setsList = response.result.items
                }
                loader(this, false)
            }).catch((error) => {
                message(this, constants.messageType.ERROR, (error))
                loader(this, false)
            })
        },
        async fetchUserDetails(orgID) {
            let body = { searchText: this.searchValueUser }
            let params = `?skip=${this.skip}&limit=${this.limit}&sort=${this.sort}&order=${this.order}`
            await getIamUsers(orgID, params, body).then((res) => {
                loader(this, true)
                let data = res && res.result.items
                if (data) {
                    this.userTableDataCount = res && res.result && res.result.items.total_count;
                    this.userData = data
                }
                else this.createBtnDisabled = true
                loader(this, false)
            }).catch((error) => {
                message(this, constants.messageType.ERROR, (error))
                loader(this, false)
            })
        },
        changeGroup(id) {
            this.bulkUpdateData.groupIds = id
            let groupIdName = find(this.setsList, { _id: (id) })
            this.groupIdName = groupIdName.userDetails[0].screen_name
        },
        /**
         * infinite loading handler collection
         */
        handleCollectionInfiniteLoading() {
            if (!this.isFetchingCollections && this.isLoadMore) this.fetchCollections(true)
        },
        changeValues(type) {
            if (!this.markedItems.includes(type)) {
                this.markedItems.push(type)
            } else {
                const index = this.markedItems.indexOf(type)
                if (index > -1) this.markedItems.splice(index, 1)
            }
        },
        changeCheckedValues(type) {
            if (!this.checkedData.includes(type)) {
                this.checkedData.push(type)
            } else {
                const index = this.checkedData.indexOf(type)
                if (index > -1) this.checkedData.splice(index, 1)
            }
        },
        confirmButton() {
            this.isProgress = true
            this.progress = 15
            let body = this.getBody()
            if (isEmpty(this.checkedData) || isEmpty(body)) {
                this.isProgress = false
                message(this, constants.messageType.ERROR, "No fields added for updation")
                return
            }
            
            body.organisationId = this.organsiationID
            console.log('userGroupBulkEdit', body)
            userGroupBulkEdit(body).then(() => {
                this.progress = 100
                this.step = 3
                this.isFinal = true
            }).catch(error => {
                console.warn('error', error)
                this.isProgress = false
            })
        },
        getBody() {
            let body = {
                group_members: [],
                groupIds: this.markedTableItems
            }
            let data = cloneDeep(this.checkedData)
            if (data.includes('group_members')) {
                let group_members = uniq(this.groupMemberList)
                body.group_members = group_members
            }

            if (data.includes('addToSet') && this.bulkUpdateData.addToSet == 'NO') {
                body.addToSet = false 
            } else if (data.includes('addToSet') && this.bulkUpdateData.addToSet == 'YES') {
                body.addToSet = true
            } else {
                delete body.addToSet
            }

            return body
        }
    }
}